define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var HolderValidationViewModel = (function () {
        function HolderValidationViewModel(propertyName, characterPosition, numberOfCharacters, inputedValue, startIndex, sourceLength) {
            this.propertyName = null;
            this.inputedValue = null;
            this.startIndex = null;
            this.sourceLength = null;
            this.propertyName = propertyName;
            this.characterPosition = characterPosition;
            this.numberOfCharacters = numberOfCharacters;
            this.inputedValue = inputedValue;
            this.startIndex = startIndex;
            this.sourceLength = sourceLength;
        }
        return HolderValidationViewModel;
    }());
    exports.default = HolderValidationViewModel;
});
